import PropTypes from 'prop-types'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import styles from './DetailRow.module.scss'

const propTypes = {
  /**
   * Message id of the label
   */
  label: PropTypes.string.isRequired,
  /**
   * Detail value
   */
  value: PropTypes.node.isRequired,
}

const defaultProps = {}

function DetailRow(props) {
  const { label, value } = props

  return (
    <Row className={styles.row}>
      <Col sm="3" md="3" lg="3">
        <p className="text-bold text-color-secondary m-0">{label && <FormattedMessage id={label} />}:</p>
      </Col>
      <Col sm="7" md="7" lg="7">
        <p className="m-0">
          {value || (
            <span className="text-color-secondary">
              <FormattedMessage id="GENERAL.NONE" />
            </span>
          )}
        </p>
      </Col>
    </Row>
  )
}

DetailRow.propTypes = propTypes
DetailRow.defaultProps = defaultProps

export default DetailRow
